define([
	"dojo/_base/declare",
	"csi/heading/AggregateController",
	"csi/widget/MessageDialog",
	"csi/xml",
	"./SizeChartSizesMixin"
], function(declare, AggregateController, MessageDialog, xml, SizeChartSizesMixin) {

	return declare([AggregateController, SizeChartSizesMixin], {
		publish() {
			// summary: confirm action before continuing
			if (xml.isValidURL(this.getNode().SizeRange)) {
				this.confirmAction({});
			} else {
				this.inherited(arguments);
			}
		},

		getConfirmButton() {
			return MessageDialog.BUTTON_CHANGE;
		},

		/**
		 * @override
		 * Selecting a new size range is required if there is already an existing 2d size range
		 */
		isValueRequired() {
			return this.inherited(arguments) || this._hasTwoDimSizeRange(this.getContext());
		},

		onConfirm(/*String*/key) {
			// summary: if configured to confirm action, then start now that confirmed
			if (key == MessageDialog.BUTTON_CHANGE) {
				AggregateController.prototype.publish.call(this);
			} else {
				this.postProcess();
			}
		}
	});
});